<!-- ! Progress -->
<h3 class="c-stop-heading u-heading">{{ 'voyage.capacityTitle' | translate }}</h3>

@if (activeVoyageSegment()) {
<p class="c-stop-progress__state c-bulleted-text">
    <span class="c-tag" [class.context:neutral]="isShowingArrival()" [class.context:success]="!isShowingArrival()">
        {{ (isShowingArrival() ? 'voyage.capacityBeforeCall' : 'voyage.capacityAfterCall') | translate }}
    </span>
</p>
}

<!-- Line Meters -->
<div class="c-stop-progress__item">
    <h4 class="c-stop-progress__title c-stop-title">
        {{ 'voyage.lineMetersUsed' | translate }}
        <span>
            ({{ activeVoyageSegment()?.occupiedCapacity?.linearMeters?.toFixed(2) }} /
            {{ activeVoyageSegment()?.totalCapacity?.linearMeters?.toFixed(2) }})
        </span>
    </h4>

    <core-progress-bar [progress]="activeVoyageSegment()?.occupiedPercentage?.linearMeters ?? 0"
        [size]="progressBarSizeConfig" />
</div>

<!-- Tons -->
<div class="c-stop-progress__item">
    <h4 class="c-stop-progress__title c-stop-title">
        {{ 'voyage.tonsUsed' | translate }}
        <span>
            ({{ activeVoyageSegment()?.occupiedCapacity?.weightTons?.toFixed(2) }} / {{
            activeVoyageSegment()?.totalCapacity?.weightTons?.toFixed(2) ?? 0.00 }})
        </span>
    </h4>
    <core-progress-bar [progress]="activeVoyageSegment()?.occupiedPercentage?.weightTons ?? 0"
        [size]="progressBarSizeConfig" />
</div>

<!-- Square Meters -->
<div class="c-stop-progress__item">
    <h4 class="c-stop-progress__title c-stop-title">
        {{ 'voyage.squareMetersUsed' | translate }}
        <span>
            ({{ activeVoyageSegment()?.occupiedCapacity?.squareMeters?.toFixed(2) }} /
            {{ activeVoyageSegment()?.totalCapacity?.squareMeters?.toFixed(2) }})
        </span>
    </h4>

    <core-progress-bar [progress]="activeVoyageSegment()?.occupiedPercentage?.squareMeters ?? 0"
        [size]="progressBarSizeConfig" />
</div>

@if (variation(); as variation) {
<div class="u-push-t">
    <h4 class="c-stop-progress__title c-stop-title">{{ 'voyage.capacityVariation' | translate }}</h4>
    <p class="c-kv-row">
        <span>{{ 'voyage.lineMetersUsed' | translate }}:</span>
        <span class="c-kv-row__value">{{ variation.linearMeters > 0 ? '+' : '' }}{{
            variation.linearMeters.toFixed(2) }}</span>
    </p>
    <p class="c-kv-row">
        <span>{{ 'voyage.squareMetersUsed' | translate }}:</span>
        <span class="c-kv-row__value">{{ variation.squareMeters > 0 ? '+' : '' }}{{
            variation.squareMeters.toFixed(2) }}</span>
    </p>
    <p class="c-kv-row">
        <span>{{ 'voyage.tonsUsed' | translate }}:</span>
        <span class="c-kv-row__value">{{ variation.weightTons > 0 ? '+' : '' }}{{
            variation.weightTons.toFixed(2) }}</span>
    </p>
</div>
}

@if (arrivalVoyageSegment() || departureVoyageSegment()) {
<div class="c-stop-info__actions u-push-t--xl u-flex--wrap">
    @if (arrivalVoyageSegment()) {
    <button type="button" class="c-stop-info__action c-btn"
        [disabled]="activeVoyageSegment()?.id === arrivalVoyageSegment()?.id" (click)="onArrival()">
        <span class="fa-solid fa-arrow-right-to-bracket"></span>
        {{ 'voyage.showArrival' | translate }}
    </button>
    }
    @if (departureVoyageSegment()) {
    <button type="button" class="c-stop-info__action c-btn"
        [disabled]="activeVoyageSegment()?.id === departureVoyageSegment()?.id" (click)="onDeparture()">
        <span class="fa-classic fa-solid fa-arrow-right-from-bracket"></span>
        {{ 'voyage.showDeparture' | translate }}
    </button>
    }
</div>
}